














import { mixins } from 'vue-class-component';
import { Component, Emit, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import { Validation } from 'vuelidate';

@Component
export default class FieldFile extends Vue {
  @Prop() readonly validation!: Validation
  @Prop({ default: 'Field' }) readonly label!: string
  @Prop() value!: File


  @Emit('input')
  input() {
    return (this.$refs.file as any).files[0];
  }
}
